// import catalogs from './catalogs'
// import catalogById from './catalog'
import category from './category'
import categories from './categories'
import featuredLists from './featuredLists'
import itemDetail from './itemDetail'
import feature from './feature'

export { category, categories, featuredLists, itemDetail, feature }



// WEBPACK FOOTER //
// ./src/reducers/index.js